"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLUMNS_ORDER = exports.COLUMNS = exports.ColumnName = void 0;
var ColumnName;
(function (ColumnName) {
    ColumnName["Details"] = "Details";
    ColumnName["Units"] = "Units";
    ColumnName["UnitPrice"] = "UnitPrice";
    ColumnName["VatPercentage"] = "VatPercentage";
    ColumnName["TotalWithoutTaxes"] = "TotalWithoutTaxes";
})(ColumnName = exports.ColumnName || (exports.ColumnName = {}));
exports.COLUMNS = {
    [ColumnName.Details]: {
        size: '1fr',
        style: {},
    },
    [ColumnName.TotalWithoutTaxes]: {
        size: '15%',
        style: { textAlign: 'right' },
    },
    [ColumnName.UnitPrice]: {
        size: '10%',
        style: { textAlign: 'right' },
    },
    [ColumnName.Units]: {
        size: '10%',
        style: { textAlign: 'right' },
    },
    [ColumnName.VatPercentage]: {
        size: '10%',
        style: { textAlign: 'right' },
    },
};
exports.COLUMNS_ORDER = [
    ColumnName.Details,
    ColumnName.Units,
    ColumnName.UnitPrice,
    ColumnName.VatPercentage,
    ColumnName.TotalWithoutTaxes,
];
